import React from "react";

const ConfirmModal = ({ onConfirm, onCancel, text }) => {
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <h2 className="confirm-modal-heading">Confirm Action</h2>
        <p className="confirm-modal-text">{text}</p>

        <div className="modal-btn-grp">
          <button className="org-modal-btn cancel-modal-btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="org-modal-btn confirm-modal-btn" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
